import { render, staticRenderFns } from "./monitor-dashboard.vue?vue&type=template&id=8b5fcb72&scoped=true&"
import script from "./monitor-dashboard.vue?vue&type=script&lang=js&"
export * from "./monitor-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./monitor-dashboard.vue?vue&type=style&index=0&id=8b5fcb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5fcb72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VIcon,VOverlay,VProgressCircular,VSheet,VToolbar,VToolbarTitle})
